<div [ngxSummernote]="config"
    [ngxSummernoteView]="text"
    [ngxSummernoteDisabled]="true"></div>
